import React from "react";
import { Tag } from "@familyzone/component-library";

interface FirewallPolicyPillProps {
  type: "block" | "allow" | "bypass";
}

const FirewallPolicyPill: React.FC<FirewallPolicyPillProps> = ({ type }) => {
  switch (type) {
    case "block":
      return <Tag variant="orange" tagLeftIcon="fa fa-ban" tagLabel="Block" />;
    case "allow":
      return <Tag variant="green" tagLeftIcon="fa fa-check" tagLabel="Allow" />;
    case "bypass":
      return <Tag variant="brand" tagLeftIcon="fa fa-check" tagLabel="Bypass" />;
  }
};

export default FirewallPolicyPill;
